import { render, staticRenderFns } from "./right_plantar_foot_b.vue?vue&type=template&id=9b86f54e"
import script from "./right_plantar_foot_b.vue?vue&type=script&lang=js"
export * from "./right_plantar_foot_b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports